<app-card-layout-content class="temporary-block-page">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <app-feedback-failure-svg-icon></app-feedback-failure-svg-icon>
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Blocco temporaneo</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <p class="p-text-center p-mb-5" i18n>
        A causa dei numerosi tentativi di richiesta o inserimento del codice OTP, abbiamo momentaneamente bloccato
        l’operazione.
      </p>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
  <app-input-container *ngIf="temporaryBlockCountdown$ | async as countdown" class="temporary-block-page__countdown">
    <span id="label" class="p-sr-only">
      {{ messageLabel }}
    </span>
    <div class="p-d-flex p-flex-column p-ai-center" aria-labelledby="label" aria-hidden="true">
      <span>{{ newCodeLabel }}</span>
      <div class="p-text-bold">
        <span>{{ countdown | countdownClockStyle }}</span>
      </div>
    </div>
  </app-input-container>
  <div class="p-mt-auto">
    <div class="p-d-flex p-flex-column p-ai-center p-mb-3">
      <span i18n>Hai bisogno di supporto?</span>
      <a class="p-mt-1 p-text-bold" [href]="'tel:' + helplineNumber" i18n>Contatta l’assistenza</a>
    </div>
    <button
      class="temporary-block-page__send-button"
      i18n-label="TemporaryBlock|Label button invia di nuovo"
      label="Invia di nuovo"
      pButton
      [disabled]="temporaryBlockCountdown$ | async"
      (click)="onSendButtonClick()"
    ></button>
  </div>
</app-card-layout-content>
